// Adds an element to an array if it doesn't exist, or removes it if it does

interface Array<T> {
  toggle(element): Array<T>;
}

Array.prototype.toggle = function(element) {
  let newArray = this;
  if (this.includes(element)) {
    newArray = this.filter((arrayItem) => arrayItem !== element)
  } else {
    newArray.push(element)
  }
  return [...newArray];
};
